// The help page's data, written into its HTML at build time by
// scripts/prerender-meta.js (#1143). Starting from it means React shows the article at
// once instead of "Loading…" over the static copy it just replaced. The hooks still
// refetch, because an article edited since the last deploy is newer in the API.
import { ArticleItem, ArticleListItem } from '../types/helpArticles';

const DATA_ID = 'chaptery-help-data'; // scripts/lib/helpHtml.js writes this id

type HelpData = { article?: ArticleItem; list?: ArticleListItem[] };
let cache: HelpData | null | undefined;

function read(): HelpData | null {
  if (cache !== undefined) return cache;
  const text = document.getElementById(DATA_ID)?.textContent;
  try {
    cache = text ? (JSON.parse(text) as HelpData) : null;
  } catch {
    cache = null;
  }
  return cache;
}

/** The prerendered article, only if it is the one for this slug. */
export function prerenderedArticle(slug: string): ArticleItem | null {
  const a = read()?.article;
  return a && a.slug === slug ? a : null;
}

export function prerenderedList(): ArticleListItem[] | null {
  const l = read()?.list;
  return Array.isArray(l) ? l : null;
}

/** A list fetched this session is newer than the built one: later mounts start from it. */
export function rememberList(list: ArticleListItem[]): void {
  cache = { ...(read() ?? {}), list };
}

/** For tests: forget the cached read. */
export function resetPrerenderedHelp(): void {
  cache = undefined;
}
